import { request } from "../../httpClient";

type TRequestData = {
  phone: string;
};

export const createUserRequest = async (arg: TRequestData) => {
  if (arg.phone[0] !== "+") {
    arg.phone = `+${arg.phone}`;
  }
  const res = await request({
    path: "user/protected/user-create",
    method: "POST",
    body: JSON.stringify(arg),
  });
  return res;
};
